// TalkShop services mock data
import { TalkShop } from "./talkShop.service.types";

export const mockTalkShop: TalkShop = {};
